"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Corporate = void 0;
class Corporate {
    constructor(props) {
        this.authorizedCorporates = props.authorizedCorporates || [];
        this.manageMultipleCorporate = props.manageMultipleCorporate || false;
        this.copago = props?.copago || null;
        this.copago_nocturno = props?.copago_nocturno || null;
        this.copay = props?.copay || null;
        this.country = props?.country || null;
        this.docId = props?.docId || null;
        this.dt_padrones_last_update = props?.dt_padrones_last_update || null;
        this.exclusive_online_doctor = props?.exclusive_online_doctor || null;
        this.name = props?.name || null;
        this.nuic = props?.nuic || null;
        this.plans = props?.plans || null;
        this.service = props?.service || null;
        this.loginType = props?.loginType || null;
        this.validationPersistence = props?.validationPersistence || true;
        this.validatedBy = props?.validatedBy || null;
        this.affiliateIdIsRequired = props?.affiliateIdIsRequired || true;
        this.affiliateIdRegex = props?.affiliateIdRegex || null;
        this.copayGroup = props?.copayGroup || null;
    }
}
exports.Corporate = Corporate;
